import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

const TOKEN_KEY = 'token-avalservi';

export const ErrorCatchingInterceptorFn: HttpInterceptorFn = (request, next) => {
  const token = localStorage.getItem(TOKEN_KEY);
  const modifiedReq = request.clone({
    ...(token && {
      headers: request.headers.set('authorization', `Bearer ${token}`)
    })
  });

  return next(modifiedReq).pipe(
    catchError((err: HttpErrorResponse) => throwError(() => err))
  );
};
